<template>
    <v-fab
        class="report-button"
        icon="icon-bug"
        color="#3FB8D7"
        size="x-small"
        @click="dialogOpen = !dialogOpen"
    />
    <ReportDialog
        v-if="dialogOpen"
        v-model="dialogOpen"
    />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

import ReportDialog from '../reportDialog/ReportDialog.vue';

import { type Languages, useTranslations } from '../../composables';

export interface ReportButtonProps {
    languageCode: Languages;
};

const props = defineProps<ReportButtonProps>();

const { languageCode } = useTranslations();

const dialogOpen = ref(false);

watch(() => props.languageCode, (): void => {
    languageCode.value = props.languageCode;
}, { immediate: true });
</script>

<style scoped lang="scss">
@use 'ReportButton.scss';
</style>